const baseUrl = '/api/v1/settings';
export const getShipoutShutdownSettings = `${baseUrl}/shipout-shutdown`;